import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import TableForm from '@mpc/common/src/components/TableForm';
import POPOUserList from '@mpc/common/src/features/POPOUserList';
import { Button, Tag } from '@bedrock/components';
import CopyIcon from '@mpc/common/src/components/CopyIcon';
import CurrencyType from "@mpc/common/src/components/SForm/SFormElement/CurrencyType";
import OAStatusTag from '@mpc/common/src/features/MPCList/commonCell/OAStatusTag';
import style from './index.less';

const cx = classNames.bind(style);

// 预付款信息类型定义
interface PrePayInfoVo {
  expense_control_no?: string;
  payment_status_desc?: string;
  amount?: number;
  payment_initiator_name?: string;
  payment_initiator_email?: string;
  expense_control_created_time?: string;
  payment_time?: string; 
  payment_record?: string;
}

type Props = {
  data?: PrePayInfoVo[];
};

const PrepaymentProcess: React.FC<Props> = forwardRef((props, ref) => {
  const { data = [] } = props;
  return (
    <div className={cx('tableFormBox')}>
      <TableForm
        scroll={{ x: 'max-content', y: 500 }}
        value={data?.filter(item => item) || []}
        emptyText="暂无数据"
        formProps={{}}
        formColumns={({ add, remove }) => [
          {
            title: <div className={cx('bold')}>MPC预付单号</div>,
            dataIndex: 'prepayment_no',
            width: 120,
            align: 'left',
            fixed: 'left',
            render: (text, record, index) => {
              if (!text) return '--';
              return (
                <div className={cx('bold', 'flex items-center')}>
                  <Button
                    type="link"
                    onClick={() => {
                      window.open(`/#/myWorkBench/myWorkBenchOther/myWorkBenchDemandPrepayment/all?projectId=${record?.id}`);
                    }}
                  >
                    {text}
                  </Button>
                  <CopyIcon text={text} tipToolTitle="复制" />
                </div>
              );
            },
          },
          {
            title: <div className={cx('bold')}>状态</div>,
            dataIndex: 'status',
            width: 100,
            align: 'left',
            render: (status, record, index) => {
              const statusColorMap = {
                'ABANDONED':  'grey',
                'PENDING_INITIATE':  'orange',
                'PENDING_INVOICE':  'blue',
                'IN_APPROVAL':  'blue',
                'PENDING_PAYMENT':  'blue',
                'COMPLETED':  'green',
              };
              return <Tag size="small" text={record?.status_desc} color={`light-${statusColorMap[status]}` as any} />
            },
          },
          {
            title: <div className={cx('bold')}>发票方式</div>,
            dataIndex: 'invoice_method_desc',
            width: 160,
            align: 'left',
            render: (text) => {
              return text || '--';
            },
          },
          {
            title: <div className={cx('bold')}>预付金额</div>,
            dataIndex: 'prepayment_amount',
            width: 144,
            align: 'right',
            render: (amount, record, index) => {
              if (!amount) return '--';
              return (
                <CurrencyType
                  view
                  showAmountOrder={false}
                  currencyColor="black"
                  value={{
                    value: amount,
                    currency: record.currency,
                  }}
                />
              );
            },
          },
          {
            title: <div className={cx('bold')}>OA状态</div>,
            dataIndex: 'oa_status',
            width: 76,
            align: 'left',
            render: (status: string) => {
              return <OAStatusTag status={status} />
            },
          },
          {
            title: <div className={cx('bold')}>OA流程号</div>,
            dataIndex: 'oa_process_no',
            width: 210,
            align: 'left',
            render: (text, record, index) => {
              if (!text) return '--';
              return (
                <div className={cx('flex items-center')}>
                  {
                    record?.oa_url ? (
                      <Button
                        type="link"
                        onClick={() => {
                          window.open(record?.oa_url);
                        }}
                      >
                        {text}
                      </Button>
                    ) : (
                      <span>{text}</span>
                    )
                  }
                  <CopyIcon text={text} tipToolTitle="复制OA流程号" />
                </div>
              );
            },
          },
          {
            title: <div className={cx('bold')}>创建人</div>,
            dataIndex: 'creator_name',
            width: 96,
            align: 'left',
            render: (text, record, index) => {
              const principal = text;
              return principal?.length ? <POPOUserList list={[{ name: text, email: record.creator_email },]} /> : '--'
            },
          },
          {
            title: <div className={cx('bold')}>创建时间</div>,
            dataIndex: 'created_at',
            width: 200,
            align: 'left',
            render: (time) => {
              return time || '--';
            },
          },
          {
            title: <div className={cx('bold')}>操作</div>,
            dataIndex: 'operation',
            width: 52,
            align: 'left',
            fixed: 'right',
            render: (time, record, index) => {
              return <Button type='link' onClick={() => {
                window.open(`/#/myWorkBench/myWorkBenchOther/myWorkBenchDemandPrepayment/all?projectId=${record?.id}`)
              }}>查看</Button>;
            },
          },
        ]}
      />
    </div>
  );
});

export default PrepaymentProcess;
